import AthleteUserViews from '../../views/entry/athleteUser/AthleteUserViews';

import EntryNavLinks from "../../views/entry/EntryNavLinks";

const INITIAL_STATE = [
  {
    name: AthleteUserViews.OME_MEET_CONTACTS,
    displayName: 'Contacts',
    path: EntryNavLinks.ATHLETE_CONTACTS,
    isCurrent: false,
    isComplete: false,
    isVisited: false,
    arePrerequisitesDone: false
  },
  {
    name: AthleteUserViews.OME_MEET_ROSTER_ENTRIES_DETAIL,
    displayName: 'Entries',
    path: EntryNavLinks.ATHLETE_ENTRIES,
    isCurrent: false,
    isComplete: false,
    isVisited: false,
    arePrerequisitesDone: false
  },
  {
    name: AthleteUserViews.OME_MEET_CREDENTIALS,
    displayName: 'Credentials',
    path: EntryNavLinks.ATHLETE_CREDENTIALS,
    isCurrent: false,
    isComplete: false,
    isVisited: false,
    arePrerequisitesDone: false
  },
  {
    name: AthleteUserViews.OME_MEET_SUBMIT,
    displayName: 'Submit',
    path: EntryNavLinks.ATHLETE_PURCHASES,
    isCurrent: false,
    isComplete: false,
    isVisited: false,
    arePrerequisitesDone: false
  }];

const GetInitialStateOmeRoute = (viewName) => {
  const state = INITIAL_STATE.find(x => x.name === viewName);
  return JSON.parse(JSON.stringify(state || {}));
};

export default GetInitialStateOmeRoute;